import {FC} from 'react'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useLocation} from 'react-router'
import {checkIsActive, KTSVG, toAbsoluteUrl, WithChildren} from '../../../helpers'
import {useLayout} from '../../core'

type Props = {
  to: string
  title: string
  biIcon?: string
  dtIcon?: string
  faIcon?: string
  image?: string
  variant?: string
  target?: string
}

const AsideMenuItem: FC<Props> = ({to, title, biIcon, dtIcon, faIcon, image, variant, target}) => {
  const {pathname} = useLocation()
  const isActive = checkIsActive(pathname, to)
  const {config} = useLayout()
  const {aside} = config

  return (
    <div>
      <Link
        to={to}
        target={target}
        className={clsx(`btn btn-icon btn-bg-light btn-active-white text-active-${variant} text-hover-${variant} btn-flex flex-column flex-center`, {
          'active': isActive,
        })}
      >
        {biIcon && aside.menuIcon === 'font' && <i className={clsx('fs-1 my-2', biIcon)}></i>}
        {dtIcon && aside.menuIcon === 'svg' && <KTSVG path={dtIcon} className='svg-icon-2 my-2' />}
        {faIcon && aside.menuIcon === 'font' && <i className={clsx('fs-1 my-2', faIcon)}></i>}
        {image && <img className='h-30px my-2' src={toAbsoluteUrl(image)} style={{filter: 'grayscale(1) opacity(0.9)'}} />}
        <span
          className={clsx('fs-9 fs-lg-7 lh-sm d-lg-block pt-1', {
            'fw-normal': !isActive,
            'fw-bold': isActive,
          })}
        >
          {title}
        </span>
      </Link>
    </div>
  )
}

export {AsideMenuItem}
